module.exports = __webpack_public_path__ + "static/img/5新能源.fed2be10.jpg";